import { mapState, mapActions, mapMutations } from "vuex";
import AppPopover from "@/components/AppPopover";
import CurrencyValue from "@/components/tableElements/CurrencyValue.vue";
export default {
  name: "TrendingPopover",
  components: {
    AppPopover,
    CurrencyValue
  },
  props: {
    portfolio: {
      type: Object,
      required: true
    },
    target: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      trending_revenue_details: {
        ytd: {
          label: "YTD",
          last_year: "previous_year_revenue_ytd",
          vs: "revenue_ytd_evol_vs_last_year",
          current_year: "current_revenue_ytd"
        },
        mtd: {
          label: "MTD",
          last_year: "previous_year_revenue_mtd",
          vs: "revenue_mtd_evol_vs_last_year",
          current_year: "current_revenue_mtd"
        },
        wtd: {
          label: "WTD",
          last_year: "previous_year_revenue_wtd",
          vs: "revenue_wtd_evol_vs_last_year",
          current_year: "current_revenue_wtd"
        }
      }
    };
  },
  computed: {
    ...mapState({}),
    processedTrendingValue() {
      return val => {
        if (!val) return "gray";
        return val > 1 ? "green-200" : val > 0.65 ? "green-100" : val > 0.3 ? "green-50" : val > 0 ? "green-25" : val == 0 ? "gray" : val >= -0.3 ? "red-25" : val >= -0.65 ? "red-50" : val > -1 ? "red-100" : "red-200";
      };
    },
    trendingValue() {
      return val => {
        if (!val) return "-";
        const value = (val * 100).toFixed(0);
        return value > 0 ? `+${value}%` : `${value}%`;
      };
    }
  }
};